import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import {
  PHIEU_DAT_PHONG_HOP_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_WAITING_APPROVAL_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_APPROVED_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL,
  PHIEU_DAT_PHONG_HOP_CALENDAR_PREFIX_URL,
} from './constants/config.phieu-dat-phong-hop'

const ListPageAll = lazy(() => import('./pages/ListPage.All.PhieuDatPhongHop'))
const ListPageWaitingApprove = lazy(
  () => import('./pages/ListPage.WaitingApprove.PhieuDatPhongHop')
)
const ListPageApproved = lazy(
  () => import('./pages/ListPage.Approved.PhieuDatPhongHop')
)

const DetailPage = lazy(() => import('./pages/DetailPage.PhieuDatPhongHop'))
const ReportPageByResource = lazy(
  () => import('./pages/ReportPage.ByPhongHop.PhieuDatPhongHop')
)
const ReportPageByPhongBan = lazy(
  () => import('./pages/ReportPage.ByPhongBan.PhieuDatPhongHop')
)
const CalendarPage = lazy(() => import('./pages/CalendarPage.PhieuDatPhongHop'))

const listRouters: AppRouterItem[] = [
  {
    path: PHIEU_DAT_PHONG_HOP_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAll />
      </LoadingLazyComponents>
    ),
  },
  {
    path: PHIEU_DAT_PHONG_HOP_WAITING_APPROVAL_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageWaitingApprove />
      </LoadingLazyComponents>
    ),
  },
  {
    path: PHIEU_DAT_PHONG_HOP_APPROVED_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageApproved />
      </LoadingLazyComponents>
    ),
  },
]

const detailRouters: AppRouterItem[] = listRouters.map((listRoute) => ({
  path: `${listRoute.path}/:phieuDatPhongHopId`,
  element: (
    <LoadingLazyComponents loadingType="skeleton">
      <DetailPage />
    </LoadingLazyComponents>
  ),
}))

const PhieuDatPhongHopRouters: AppRouterItem[] = [
  ...listRouters,
  ...detailRouters,
  {
    path: `${PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL}/by-phong-hop`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPageByResource />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PHIEU_DAT_PHONG_HOP_REPORT_PREFIX_URL}/by-phong-ban`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPageByPhongBan />
      </LoadingLazyComponents>
    ),
  },
  {
    path: PHIEU_DAT_PHONG_HOP_CALENDAR_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <CalendarPage />
      </LoadingLazyComponents>
    ),
  },
]

export default PhieuDatPhongHopRouters
